import { Card } from '../../../design-system/components';
import SectionHeading from '../components/SectionHeading';
import FAQItem from '../components/FAQItem';
import { faqs } from '../data/faq-data';

export default function FAQSection() {
  return (
    <section id="faq" className="ee-landing-section">
      <div className="ee-landing-container ee-landing-container--narrow">
        <SectionHeading
          title="Frequently Asked Questions"
          subtitle="Everything you need to know before getting started."
        />

        <Card padding="none" className="ee-landing-faq">
          {faqs.map((faq) => (
            <FAQItem key={faq.question} question={faq.question} answer={faq.answer} />
          ))}
        </Card>
      </div>
    </section>
  );
}
